import { render, staticRenderFns } from "./self-weighing.vue?vue&type=template&id=38233407&scoped=true&"
import script from "./self-weighing.vue?vue&type=script&lang=js&"
export * from "./self-weighing.vue?vue&type=script&lang=js&"
import style0 from "./self-weighing.vue?vue&type=style&index=0&id=38233407&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38233407",
  null
  
)

export default component.exports